var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-about-vacancies"},[_c('div',{staticClass:"col-container"},[_c('div',{staticClass:"col-left"},[_c('div',{staticClass:"vacancies-desc",domProps:{"innerHTML":_vm._s(_vm.aboutPage.work_desc)}})]),_c('div',{staticClass:"col-right"},[_c('formVacancy')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }